import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { 
  Zap, 
  Shield, 
  Smartphone, 
  Globe, 
  Users, 
  Lock 
} from 'lucide-react';

const features = [
  {
    icon: Zap,
    title: 'Instant Conversion',
    description: 'Text transforms in milliseconds with no server delays. All processing happens locally in your browser.'
  },
  {
    icon: Shield,
    title: '100% Private',
    description: 'Your text never leaves your device. We don\'t store, track, or share anything you type.'
  },
  {
    icon: Smartphone,
    title: 'Works Everywhere',
    description: 'Fully responsive design that works seamlessly on desktop, tablet, and mobile devices.'
  },
  {
    icon: Globe,
    title: 'No Sign-up Required',
    description: 'Start using immediately without creating an account, providing an email, or any friction.'
  },
  {
    icon: Users,
    title: 'Built for Everyone',
    description: 'Writers, marketers, developers, students, and social media managers all rely on clean text.'
  },
  {
    icon: Lock,
    title: 'Always Free',
    description: 'Core features are free forever. Convert as much text as you need without limits.'
  }
];

export const FeaturesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-4">
              Why Use CaseFlip?
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              A simple tool designed for speed, privacy, and ease of use
            </p>
          </div>

          {/* Features grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <Card 
                key={index} 
                className="border-border/50 bg-card hover:shadow-md transition-shadow duration-300 group"
              >
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/15 transition-colors">
                      <feature.icon className="h-5 w-5 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground mb-2">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
